import React from 'react';
import { Box, Button, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import {
  TOAST_BG,
  TOAST_CLOSE,
  TOAST_TEXT,
  TOAST_VARIANTS,
} from './toastConfig';

/**
 * Visual: fondo oscuro, acento izquierdo por severidad, ícono + mensaje + acción/close.
 */
export default function Toast({
  type = 'success',
  title,
  message,
  closable = true,
  actionLabel,
  onAction,
  onClose,
}) {
  const variant = TOAST_VARIANTS[type] || TOAST_VARIANTS.info;
  const { accent, iconBg, iconColor = '#fff', Icon } = variant;
  const hasAction = Boolean(actionLabel && onAction);

  return (
    <Box
      role="status"
      aria-live="polite"
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
        minWidth: { xs: 'calc(100vw - 32px)', sm: 360 },
        maxWidth: { xs: 'calc(100vw - 32px)', sm: 560 },
        py: 1.5,
        pl: 2,
        pr: closable || hasAction ? 1 : 2,
        bgcolor: TOAST_BG,
        borderRadius: '8px',
        borderLeft: `3px solid ${accent}`,
        boxShadow: '0 8px 24px rgba(0,0,0,0.35)',
        pointerEvents: 'auto',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: 32,
          height: 32,
          flexShrink: 0,
          borderRadius: '6px',
          bgcolor: iconBg,
        }}
      >
        <Icon sx={{ fontSize: 20, color: iconColor }} />
      </Box>

      <Typography
        sx={{
          flex: 1,
          minWidth: 0,
          fontFamily: 'Inter, sans-serif',
          fontWeight: 400,
          fontSize: 14,
          lineHeight: '20px',
          color: TOAST_TEXT,
        }}
      >
        {title ? (
          <>
            <Box component="span" sx={{ fontWeight: 700 }}>
              {title}
            </Box>
            {message ? ` ${message}` : null}
          </>
        ) : (
          message
        )}
      </Typography>

      {hasAction && (
        <Button
          onClick={onAction}
          size="small"
          sx={{
            flexShrink: 0,
            textTransform: 'none',
            color: TOAST_TEXT,
            fontSize: 14,
            fontWeight: 500,
            minWidth: 0,
            px: 0.5,
            textDecoration: 'underline',
            textUnderlineOffset: '2px',
            '&:hover': {
              bgcolor: 'transparent',
              textDecoration: 'underline',
            },
          }}
        >
          {actionLabel}
        </Button>
      )}

      {closable && !hasAction && (
        <IconButton
          aria-label="Cerrar notificación"
          onClick={onClose}
          size="small"
          sx={{
            color: TOAST_CLOSE,
            flexShrink: 0,
            '&:hover': { bgcolor: 'rgba(255,255,255,0.08)' },
          }}
        >
          <CloseIcon sx={{ fontSize: 18 }} />
        </IconButton>
      )}
    </Box>
  );
}
